import { render } from "./WhoCanView.vue?vue&type=template&id=7a029a15&ts=true"
import script from "./WhoCanView.vue?vue&type=script&lang=ts"
export * from "./WhoCanView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__